import { useUser } from '#app/hooks/useUser'

interface SignedInProps {
	children: React.ReactNode
}

export function SignedIn({ children }: SignedInProps) {
	const { isSignedIn } = useUser()

	return isSignedIn ? <>{children}</> : null
}
